<template>
  <div class="top-potential-recommendations">
    <!-- Header for Top Potential Stocks -->
    <div class="header">
      <span>Top Potential Stocks</span>
      <span class="view-all">View all ({{ topPotentialStocks.length }})</span>
    </div>

    <!-- Row for Top Potential Stocks -->
    <el-row class="scroll-container" :gutter="20">
      <el-col :span="12" v-for="(stock, index) in topPotentialStocks" :key="index">
        <el-card class="recommendation-card" :body-style="{ padding: '10px' }" :style="getCardStyle(stock)">
          <div>
            <div class="card-header">
              <div class="stock-info">
                <img :src="stock.stock_logo" alt="Stock Logo" class="stock-logo" />
                <span class="stock-name">{{ stock.symbol }}</span>
              </div>
            </div>

            <div class="card-body">
              <div class="target-info">
                <div>
                  <span class="remaining-target">Remaining Target</span>
                  <span class="value-percent">{{ stock.remainingTarget }}%</span>
                </div>
                <el-button class="action-btn" :style="getButtonStyle(stock.reco)" size="mini">
                  {{ stock.reco }}
                </el-button>
              </div>
            </div>
          </div>
        </el-card>
        <div class="footer-info" :style="getCardStyle(stock)">
          <img :src="stock.expert_logo" class="expert-logo" />
          <span class="timestamp">{{ stock.timestamp }}</span>
        </div>
      </el-col>
    </el-row>

    <!-- Header for Top Potential Strategies -->
    <div class="header">
      <span>Top Potential Strategies</span>
      <span class="view-all">View all ({{ topPotentialStrategies.length }})</span>
    </div>

    <!-- Row for Top Potential Strategies -->
    <el-row class="scroll-container" :gutter="20">
      <el-col :span="12" v-for="(strategy, index) in topPotentialStrategies" :key="index">
        <el-card class="recommendation-card" :body-style="{ padding: '10px' }" :style="getCardStyle(strategy)">
          <div>
            <div class="card-header">
              <div class="stock-info">
                <img :src="strategy.stock_logo" alt="Stock Logo" class="stock-logo" />
                <span class="stock-name">{{ strategy.title }}</span>
              </div>
            </div>

            <div class="card-body">
              <div class="target-info">
                <div>
                  <span class="remaining-target">Remaining Target</span>
                  <span class="value-percent">{{ strategy.remainingTarget }}%</span>
                </div>
                <el-button class="action-btn" :style="getButtonStyle(strategy.direction)" size="mini">
                  {{ strategy.direction }}
                </el-button>
              </div>
            </div>
          </div>
        </el-card>
        <div class="footer-info" :style="getCardStyle(strategy)">
          <img :src="strategy.expert_logo" class="expert-logo" />
          <span class="timestamp">{{ strategy.timestamp }}</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      topPotentialStocks: [
        {
          symbol: "AAPL industries limited",
          reco: "Buy",
          remainingTarget: 45,
          timestamp: "2025-01-16 12:00",
          stock_logo: require("@/assets/images/LC.svg"),
          expert_logo: require("@/assets/images/SC.svg"),
        },
        {
          symbol: "GOOG servent ltd",
          reco: "Sell",
          remainingTarget: 20,
          timestamp: "2025-01-15 10:30",
          stock_logo: require("@/assets/images/LC.svg"),
          expert_logo: require("@/assets/images/SC.svg"),
        },
      ],
      topPotentialStrategies: [
        {
          title: "Equity Long special",
          direction: "Buy",
          remainingTarget: 50,
          timestamp: "2025-01-16 12:00",
          stock_logo: require("@/assets/images/LC.svg"),
          expert_logo: require("@/assets/images/SC.svg"),
        },
        {
          title: "Options Short intraday banknifty sure",
          direction: "Sell",
          remainingTarget: 40,
          timestamp: "2025-01-15 10:30",
          stock_logo: require("@/assets/images/LC.svg"),
          expert_logo: require("@/assets/images/SC.svg"),
        },
      ],
    };
  },
  methods: {
    getCardStyle(item) {
      return {
        borderRight: `2px solid ${
          item.reco === "Buy" || item.direction === "Buy"
            ? "#0BA042"
            : item.reco === "Sell" || item.direction === "Sell"
            ? "#EA2526"
            : "transparent"
        }`,
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      };
    },
    getButtonStyle(reco) {
      return {
        backgroundColor: reco === "Buy" ? "#0BA042" : reco === "Sell" ? "#EA2526" : "gray",
        color: "#fff",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.top-potential-recommendations {
  margin: 0;

  .header {
    font-size: 15px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .view-all {
      font-size: 15px;
      font-weight: 500;
      color: #2D2E8D;
      cursor: pointer;
    }
  }

  .scroll-container {
    margin-bottom: 15px !important;
    row-gap: 15px; /* Proper spacing between rows */
  }

  .recommendation-card {
    background-color: #ffffff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 10px 10px 0px 0px;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .stock-info {
        display: flex;
        align-items: center;

        .stock-logo {
          width: 35px;
          height: 35px;
          margin-right: 5px;
        }

        .stock-name {
  font-weight: 600;
  font-size: 13px;
  white-space: normal; /* Allow wrapping to multiple lines */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Limit to 2 lines */
  -webkit-box-orient: vertical; /* Required for -webkit-line-clamp to work */
  max-width: 200px;
  color: #000000;
  margin-right: 5px;
}

      }
    }

    .card-body {
      .target-info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        div {
          display: flex;
          flex-direction: column;

          .remaining-target {
            font-size: 11px;
            font-weight: 500;
          }

          .value-percent {
            font-size: 15px;
            font-weight: 600;
            color: #0ba042;
            margin-top: 4px;
          }
        }

        .action-btn {
          margin-left: auto;
          padding: 6px 12px;
          border-radius: 4px;
          font-size: 10px;
          font-weight:600
        }
      }
    }
  }

  .footer-info {
    background-color: #e8eef5;
    padding: 5px 10px;
    border-radius: 0 0 10px 10px;
    display: flex;
    align-items: center;

    .expert-logo {
      width: 25px;
      height: 25px;
      margin-right: 5px;
    }

    .timestamp {
      font-size: 10px;
      font-weight: 500;
      color: #5e5e5e;
    }
  }
}

 @media (max-width: 768px) {
  .top-potential-recommendations {
  .header {
    font-size: 13px;

    .view-all {
      font-size: 12px;
    }
  }

  .scroll-container {
    margin-bottom: 15px !important;
    row-gap: 5px;
  }

  .recommendation-card {

    .card-header {
      .stock-info {

        .stock-name {
          font-size: 11px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .card-body {
      .target-info {

        div {

          .remaining-target {
            font-size: 9px;
          }

          .value-percent {
            font-size: 12px;
          }
        }

        .action-btn {
          padding: 5px 7px;
          font-size: 10px;
          font-weight:600
        }
      }
    }
  }

  .footer-info {

    .expert-logo {
      width: 15px;
      height: 15px;
    }

    .timestamp {
      font-size: 9px;
    }
  }
  }
  .el-col {
    width: 50% !important;
    flex-shrink: 0;
    padding: 0px 0px 0px 10px !important;
  }
}
</style>
